import type { ICurrentStream } from "~api/stream/interfaces";

export async function getProductSearch(searchTerm: string, stream: ICurrentStream) {
  const response = await fetch(
    `${process.env.REACT_APP_BACKEND_URL}/ecommerce/search/${searchTerm}-${stream.brand}-${stream.sales_channel}`
  );

  if (!response.ok) {
    throw new Error("Busca Falhou");
  }

  return response.json();
}
